import useLastViewedState from "@/hooks/use-last-viewed-state";
import { JobsDestination } from "@/lib/jobs-destination";
import {
  JobSearchBoard,
  useJobSearchOrigin,
} from "@/stores/use-job-search-origin";
import { usePreserveFilters } from "@/stores/use-preserve-filters";

export enum JobsStateResolution {
  Redirect = "redirect",
  SelectState = "select-state",
}

export type BestJobsStateUrl =
  | { resolution: JobsStateResolution.Redirect; url: string }
  | { resolution: JobsStateResolution.SelectState };

interface UseBestJobsStateUrlOptions {
  destination: JobsDestination;
  useLastViewedStateFn: typeof useLastViewedState;
  usePreserveFiltersFn: typeof usePreserveFilters;
  useJobSearchOriginFn: typeof useJobSearchOrigin;
}

export function useBestJobsStateUrl({
  destination,
  useLastViewedStateFn,
  usePreserveFiltersFn,
  useJobSearchOriginFn,
}: UseBestJobsStateUrlOptions): BestJobsStateUrl {
  const { stateConfig } = useLastViewedStateFn();
  const { getJobSearchUrl } = usePreserveFiltersFn();
  const { origin } = useJobSearchOriginFn();

  if (
    destination === JobsDestination.Origin &&
    origin.board === JobSearchBoard.District
  ) {
    return { resolution: JobsStateResolution.Redirect, url: origin.href };
  }

  if (!stateConfig) {
    return { resolution: JobsStateResolution.SelectState };
  }

  return {
    resolution: JobsStateResolution.Redirect,
    url: getJobSearchUrl(stateConfig),
  };
}
